import type { ContentCardVariants } from '~ds/blocks/content-card';

// The rendered photo width × 2 for retina, per card size.
const IMAGE_SIZES = {
  row: '172px md:224px',
  fill: '100vw md:300px',
  lead: '100vw md:800px',
} as const;

/**
 * The `NuxtPicture` attrs for a content card's cover, per card size. The featured block's lead
 * sits at the top of the page, so its photo is the hero, preloaded rather than deferred.
 */
export const contentCardPicture = (size: ContentCardVariants['size'] = 'row') => {
  const lead = size === 'lead';

  return {
    sizes: IMAGE_SIZES[size ?? 'row'],
    preload: lead,
    imgAttrs: {
      class: 'absolute inset-0 size-full object-cover',
      loading: lead ? 'eager' : 'lazy',
      fetchpriority: lead ? 'high' : 'auto',
    },
  };
};
